import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { CoreModel } from '../lib/fleet-live-core';
import { count, decimal } from '../lib/time';

// Core Intelligence's stage head (#6779, prototype `:3485-3487`): the h3, "<N> agents in orbit
// · <M> squads" (`agents.total`, and every squad: the shown ones plus `squads_more`), then
// "Observing every repo" and "Commits / min · <N>" (omitted, never 0, when the read sent no
// `commits`), and the panel's controls on the right.

export function FleetLiveCoreHead(props: {
  readonly model: CoreModel;
  readonly controls?: JSX.Element;
}): JSX.Element {
  const orbit = (): string => {
    const m = props.model;
    const agents = tPlural('fleet.live.orbit_agents', m.total, { count: count(m.total) });
    const squads = tPlural('fleet.live.orbit_squads', m.squadCount, {
      count: count(m.squadCount),
    });
    return t('fleet.live.orbit_line', { agents, squads });
  };
  return (
    <div class="fleet-live__core-head">
      <div>
        <h3 class="fleet-live__title">{t('fleet.live.core')}</h3>
        <p class="fleet-live__core-sub">{orbit()}</p>
      </div>
      <div class="fleet-live__core-r">
        <span class="fleet-live__core-obs">
          <i class="fleet-live__core-live" aria-hidden="true" />
          {t('fleet.live.observing')}
        </span>
        <Show when={props.model.commitsPerMinute}>
          {(rate) => (
            <span title={t('fleet.live.commits_title')}>
              {t('fleet.live.commits_rate', { count: decimal(rate()) })}
            </span>
          )}
        </Show>
      </div>
      <Show when={props.controls}>
        <div class="fleet-live__core-ctl">{props.controls}</div>
      </Show>
    </div>
  );
}
